import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';

import useI18n from 'hooks/use-i18n';
import {
  getCalendarAsync,
  resetEvents,
  getDayCalendarAsync,
} from 'store/calendar';
import LearnerCalendar from 'modules/Calendar/components/LearnerCalendarNew';
import BreadCrumbsPage from 'components/Breadcrumb/Breadcrumb';
import { USER_EVENT_TYPE, USER_METHODS } from 'constants/constants';
import { getViewMode } from 'store/auth';
import { getSelectedCentre } from 'store/master';
import { useFetchSettings } from 'hooks/settings';
import { useCheckPermission } from 'hooks/permission';
import { useUser } from 'hooks';
import { hasPermission } from 'helpers';

// ** CalendarColors
const calendarsColor = {
  Business: 'primary',
  Holiday: 'success',
  Personal: 'danger',
  Family: 'warning',
  ETC: 'info',
};

const CalendarPage = (props) => {
  const {} = props;
  const viewMode = useSelector(getViewMode);
  const selectedCentre = useSelector(getSelectedCentre);
  useCheckPermission([[USER_METHODS.GET, 'user-events', viewMode]]);
  useFetchSettings();

  const auth = useUser();

  // ** Variables
  const i18n = useI18n();
  const dispatch = useDispatch();

  // ** states
  const [addSidebarOpen, setAddSidebarOpen] = useState(false);
  const [calendarApi, setCalendarApi] = useState(null);
  const [dayCalendarApi, setDayCalendarApi] = useState(null);

  async function getEvents(begin, end) {
    try {
      let filter = {
        begin,
        end,
        types: `${USER_EVENT_TYPE.EVENT},${USER_EVENT_TYPE.WEBINAR},${USER_EVENT_TYPE.CLASSROOM},${USER_EVENT_TYPE.MSTEAMS_MEETING}`,
      };
      if (selectedCentre?._id) {
        filter.courseCentre = selectedCentre?._id;
      }
      if (!begin && !end && calendarApi) {
        filter = {
          ...filter,
          begin: dayjs(
            calendarApi.currentDataManager.state.dateProfile.activeRange.start,
          ).format(),
          end: dayjs(
            calendarApi.currentDataManager.state.dateProfile.activeRange.end,
          ).format(),
        };
      }
      filter.begin && filter.end && (await dispatch(getCalendarAsync(filter)));
    } catch (e) {
      console.log(e);
    }
  }

  useEffect(() => {
    if (selectedCentre || selectedCentre === undefined) {
      getEvents();
    }
  }, [selectedCentre]);

  // ** AddEventSidebar Toggle Function
  const handleAddEventSidebar = () => setAddSidebarOpen(!addSidebarOpen);

  const breadcrumb = [
    {
      text: i18n.t('dashboard'),
    },
    {
      text: i18n.t('calendar.title'),
      active: true,
    },
  ];

  useEffect(() => () => dispatch(resetEvents()), []);

  if (!hasPermission(USER_METHODS.GET, 'user-events', auth, viewMode)) {
    return null;
  }

  return (
    <>
      {props?.dayOrMonth ? '' : <BreadCrumbsPage data={breadcrumb} />}
      <div className="app-calendar learner-cal-border">
        {props?.dayOrMonth ? (
          <LearnerCalendar
            calendarApi={calendarApi}
            setCalendarApi={setCalendarApi}
            dayCalendarApi={dayCalendarApi}
            setDayCalendarApi={setDayCalendarApi}
            calendarsColor={calendarsColor}
            onAddEvent={handleAddEventSidebar}
            getEvents={getEvents}
            dayOrMonth={props?.dayOrMonth}
          />
        ) : null}
      </div>
    </>
  );
};

export default CalendarPage;
